<template>
  <div class="text-center text-black-50">
    <p>D-XPERTS © 2021</p>
  </div>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped></style>
